var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAirbnbCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tl1dbwhf5a",
    width: "196%",
    height: "196%",
    x: "-48%",
    y: "-48%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "vub5g09yab",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tl1dbwhf5a)",
    transform: "translate(-1058 -116) translate(1058 116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "byp7uglp3c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vub5g09yab"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#vub5g09yab"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    fillRule: "nonzero",
    stroke: "#FF5F5F",
    strokeWidth: 0.2,
    d: "M18.948 17.148c-.113.78-.68 1.456-1.47 1.757-.39.15-.81.195-1.23.15-.403-.046-.808-.166-1.228-.39-.581-.301-1.162-.767-1.841-1.458 1.066-1.216 1.712-2.327 1.955-3.318.114-.466.13-.885.081-1.276-.065-.375-.21-.72-.436-1.021-.501-.676-1.343-1.066-2.279-1.066-.937 0-1.779.405-2.279 1.066-.226.3-.372.646-.436 1.02-.065.392-.049.826.08 1.277.243.99.905 2.117 1.955 3.333-.661.691-1.26 1.157-1.841 1.456-.421.227-.824.346-1.229.39-.436.046-.856-.013-1.229-.15-.79-.299-1.357-.975-1.47-1.755-.047-.376-.016-.752.147-1.172.047-.15.128-.3.21-.48.112-.24.242-.496.37-.751l.017-.03c1.115-2.237 2.31-4.519 3.555-6.742l.049-.09c.13-.225.259-.465.387-.69.13-.24.275-.466.453-.661.34-.36.792-.555 1.294-.555.5 0 .952.195 1.292.555.178.196.323.42.453.66.128.226.258.466.387.692l.049.09c1.225 2.231 2.405 4.483 3.539 6.757v.014c.13.24.242.511.372.751.08.18.161.33.21.48.129.39.178.765.113 1.157m-6.448-.706c-.872-1.021-1.439-1.982-1.632-2.793-.082-.345-.098-.645-.05-.916.033-.24.13-.45.26-.63.307-.405.823-.661 1.422-.661.598 0 1.131.24 1.421.66.13.18.228.391.26.631.048.271.032.586-.048.916-.195.796-.76 1.757-1.633 2.793m7.288-.78c-.08-.182-.162-.377-.242-.542-.13-.27-.26-.525-.372-.765l-.016-.015c-1.115-2.252-2.312-4.534-3.572-6.787l-.048-.09c-.133-.234-.263-.469-.388-.706-.161-.27-.322-.555-.581-.826-.518-.6-1.261-.931-2.053-.931-.808 0-1.536.331-2.068.901-.243.27-.42.555-.583.826-.125.237-.255.473-.387.706l-.048.09c-1.245 2.252-2.457 4.535-3.572 6.786l-.017.03c-.112.241-.242.496-.37.766-.082.166-.162.345-.243.54-.21.556-.275 1.082-.194 1.622.177 1.126.986 2.072 2.101 2.493.42.166.856.24 1.309.24.129 0 .291-.015.42-.03.534-.06 1.082-.225 1.616-.511.663-.345 1.293-.84 2.004-1.561.711.721 1.357 1.216 2.004 1.56.533.287 1.082.451 1.616.512.13.015.291.03.421.03.451 0 .904-.074 1.308-.24 1.132-.42 1.923-1.381 2.1-2.493.13-.526.065-1.05-.145-1.606",
    mask: "url(#byp7uglp3c)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAirbnbCircle);
export default __webpack_public_path__ + "static/media/IcoAirbnbCircle.abf3042b7632f3411410facd3c181d54.svg";
export { ForwardRef as ReactComponent };